module.exports = __webpack_public_path__ + "media/assets/community/chantelle-ee27e50e9b6258e783466f6814153f8973d94c6e7081861b43b5aa2d9957f8c0.png";